export default "__VITE_ASSET__C8PFnJOq__"